<template>
    <div class="resume-container">
        <div v-if="!carregando">
            <div class="actions">
                <div class="actions-content">
                    <button class="btn btn-default" type="button" @click="() => this.$emit('voltar')" style="width: 120px">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </button>

                    <button v-if="!project" class="btn btn-primary" type="button" @click="() => this.$emit('novaPersonalizacao')">
                        <i class="fa fa-plus-circle"></i>Personalizar outro Gerador
                    </button>
                </div>
            </div>

            <div class="produto-container">
                <div v-for="produto in products" class="produto">
                    <div class="produto-custom" @click.self="() => (produto.mostrarInsumos = !produto.mostrarInsumos)">
                        <div class="produto-info" @click="() => (produto.mostrarInsumos = !produto.mostrarInsumos)">
                            <img async :src="produto.Imagem" :alt="produto.Descricao" class="produto-imagem" />
                            <div class="produto-descricao">
                                <div>
                                    <strong>{{ produto.Codigo }}</strong><br />
                                    <strong>{{ produto.Descricao }}</strong>
                                </div>
                                <div>
                                    {{ formatoCurrency(produto.valor) }}
                                </div>
                            </div>
                        </div>

                        <div class="produto-actions">
                            <div style="display: flex; gap: 10px; align-items: center; width: 175px">
                                <button aria-label="Adicionar Produto" class="btn primary-button" @click="() => subtractQtde(produto.id)">
                                    <i class="fa fa-minus-circle fa-lg"></i>
                                </button>

                                <input class="form-control text-center"
                                       type="number"
                                       v-model="produto.qtde"
                                       style="height: 38px"
                                       @blur="() => validarQtde(produto)" />

                                <button aria-label="Adicionar Produto" class="btn primary-button" @click="() => addQtde(produto.id)">
                                    <i class="fa fa-plus-circle fa-lg"></i>
                                </button>
                            </div>

                            <div class="actions-control">
                                <button class="btn btn-primary" type="button" @click="() => updateProduct(produto.id)"><i class="fa fa-pencil"></i></button>
                                <button class="btn btn-danger" type="button" @click="() => removeProduct(produto.id)"><i class="fa fa-trash"></i></button>

                                <i class="fa"
                                   @click="() => (produto.mostrarInsumos = !produto.mostrarInsumos)"
                                   :class="{ 'fa-chevron-down': !produto.mostrarInsumos, 'fa-chevron-up': produto.mostrarInsumos }"></i>
                            </div>
                            <!--  -->
                        </div>
                    </div>

                    <div class="produto-insumo" :class="{ show: produto.mostrarInsumos }">
                        <div class="insumos-header">
                            <div class="header-imagem">Imagem</div>

                            <div class="header-descricao">Descrição</div>

                            <div class="header-unidade">Un.</div>

                            <div class="header-qtde">Qtde</div>


                        </div>
                        <div class="produto-insumo-container">
                            <template v-for="(insumo, index) in produto.Insumos">
                                <template>
                                    <div class="insumo-item" v-bind:key="index">
                                        <ProductInputResume :insumo="insumo" :index="index" />
                                        <div v-if="insumo.Associados && insumo.Associados.length > 0" v-bind:key="index">
                                            <template v-for="(associado, index2) in insumo.Associados">
                                                <template>
                                                    <ProductInputResume v-bind:key="index2" :insumo="associado" :index="index" :associado="true" />
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="valor-total">Total: {{ totalFormatado }}</div>

            <div class="panel">
                <div class="panel-heading">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <label class="control-label" for="txtCEP"> Consultar frete e prazo de entrega </label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-8">
                                        <input id="txtCEP"
                                               name="txtCEP"
                                               type="text"
                                               placeholder="Inserir CEP"
                                               class="form-control input-md"
                                               v-model="frete.cep"
                                               v-mask="'#####-###'" />
                                    </div>
                                    <div class="col-xs-4">
                                        <button v-on:click="openCotacaoFrete()" class="btn btn-primary col-xs-12" :disabled="!habilitaBuscaFrete">Buscar</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <a id="linkEsqueciCep"
                                       target="_blank"
                                       href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                                       class="sc-85bbe06c-7 gXnBba">Não lembro meu CEP</a>
                                </div>
                            </div>
                            <ProductShippingDetails
                                :cep="frete.cep"
                                :totalProduto="frete.totalProduto"
                                :codigoProduto="frete.codigoProduto"
                                :qtdeProduto="frete.qtdeProduto"
                                :codigoCliente="frete.codigoCliente"
                                :peso="frete.Peso"
                                :personalizacao="true"
                                ref="modalFrete"
                                :habilitaSelecao="true" >
                            </ProductShippingDetails>
                        </div>
                    </div>
                </div>
            </div>

            <div id="app">
                <label for="terms" style="font-size: 15px; box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px; padding: 10px; background-color: #f7f7f7">
                    <ol style="font-size: 15px; display: flex; flex-direction: column; gap: 12px">
                        <li>
                            A venda de equipamentos e/ou geradores de energia fotovoltaicos pela Aldo é realizada a pedido exclusivo da Revenda para si ou para o
                            Consumidor Final, sendo de sua responsabilidade a seleção dos equipamentos e geradores fotovoltaicos que estão sendo adquiridos, devendo
                            a Revenda, verificar seu pedido antes da confirmação.
                        </li>
                        <li>
                            A ALDO não se responsabiliza por reclamações posteriores ao “envio de equipamentos e geradores fotovoltaicos” comprados equivocadamente.
                        </li>
                        <li>
                            A Aldo não realiza e não se responsabiliza ou responde por projetos, dimensionamentos, tratativas e homologações de projetos com
                            concessionárias de energia, incompatibilidade dos equipamentos e/ou geradores fotovoltaicos com a necessidade da Revenda/Consumidor
                            Final, tampouco, pela instalação dos equipamentos e/ou geradores fotovoltaicos.
                        </li>
                    </ol>
                    <input style="margin: 5px" id="terms" type="checkbox" v-model="terms" />
                    <strong>LI E CONFERI</strong> A SELEÇÃO DE EQUIPAMENTOS E GERADORES FOTOVOLTAICOS QUE CONSTAM DO PEDIDO E <strong>AUTORIZO</strong> SUA
                    EMISSÃO.
                </label>
                <p></p>
            </div>

            <div v-if="!project" style="margin-top: 16px; display: flex; gap: 10px">
                <button type="button" :disabled="isDisabled || loading" class="btn btn-block btn-warning" @click="gerarProposta">
                    <i v-if="!loading" class="fa fa-file"></i>
                    <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                    Gerar proposta
                </button>
                <button type="button" :disabled="isDisabled || loading" class="btn btn-block btn-primary" @click="comprar">
                    <i class="fa fa-shopping-cart"></i> Comprar
                </button>
            </div>

            <div v-if="!!project" style="margin-top: 16px; display: flex; gap: 10px">
                <button type="button" :disabled="isDisabled || loading" class="btn btn-block btn-warning" @click="alterarProposta">
                    <i v-if="!loading" class="fa fa-file"></i>
                    <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                    Alterar proposta
                </button>
            </div>
        </div>

        <OrderTypeModal :product="null" :customProducts="products" @clear="clear" />

        <div class="text-center" v-if="carregando">
            <div class="mensagem-carregamento">Aguarde enquanto criamos o seu novo gerador...</div>
            <Loader style="margin: 30px auto" />
        </div>

<ProposalGenerate v-if="dialogProposal"
                  :product="productProposal"
                  :dialogProposal="dialogProposal"
                  :transportadora="transportadora"
                  @close="
                  ()=>
    {
    dialogProposal = false
    $emit('scrollUp')
    }
    "
    >
</ProposalGenerate>
    </div>
</template>

<style scoped>
.resume-container {
    margin-bottom: 30px;
}

.panel {
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    background-color: #d8f1fe;
    color: #0d5a9d;
    margin-bottom: 0px;
    min-width: 190px;
    margin: 30px 0px;
}

.actions {
    padding: 20px 15px;
    background: #fafafa;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.actions-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.actions-content button {
    width: 220px;
}

button .fa {
    margin-right: 4px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.produto-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 30px 0px;
}

.produto {
    background: #d8f1fe;
}

.produto-custom {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    transition: 0.6s;
    cursor: pointer;
    background: #d8f1fe;
}

.produto-custom:hover {
    transform: scale(1.01);
}

.produto-info {
    gap: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.produto-descricao {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.produto-imagem {
    width: 75px;
    border-radius: 6px;
}

.produto-insumo {
    transition: 0.5s;
    overflow: hidden;
    display: block;
    max-height: 0px;
    opacity: 0;
    background: #fff;
}

.insumo-item {
    border-bottom: 1px solid #c4e0f7;
}

.produto-insumo.show {
    max-height: 1000px;
    opacity: 1;
}

.produto-actions {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
}

.produto-actions i {
    margin: 0px 5px;
}

.produto-actions .actions-control {
    display: flex;
    gap: 10px;
    align-items: center;
    width: 155px;
    justify-content: flex-end;
}

.valor-total {
    margin: 20px 10px 0 0;
    display: flex;
    justify-content: end;
    align-items: center;
    font-size: 30px;
    font-weight: bold;
}

.mensagem-carregamento {
    font-size: 30px;
    font-weight: bold;
    margin-top: 20px;
}

.btn {
    border-radius: 8px;
}

.primary-button {
    padding: 7px;
}

.produto-insumo .insumos-header {
    display: grid;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    grid-template-columns: 135px auto 45px 65px;
    border-radius: 4px;
    padding: 14px 10px;
    background: #efefef;
    border-bottom: 1px solid #c4e0f7;
    font-weight: 700;
}

.produto-insumo .insumos-header .header-valores {
    display: flex;
    justify-content: space-between;
}

.produto-insumo .insumos-header .header-imagem,
.produto-insumo .insumos-header .header-unidade {
    text-align: center;
}

.produto-insumo .insumos-header .header-descricao {
    padding-left: 10px;
}

.produto-insumo .insumos-header .header-qtde,
.produto-insumo .insumos-header .header-valor-unit,
.produto-insumo .insumos-header .header-valor {
    text-align: right;
}

.produto-insumo .insumos-header .header-valor {
    padding-right: 10px;
}

@media (max-width: 700px) {
    .produto-custom {
        flex-direction: column;
    }

    .insumo {
        flex-direction: column;
        height: 90px;
    }
}

.btn-block {
    height: 45px;
    font-size: 16px;
    margin-top: 0px;
}
</style>

<script>
// import BuyButton from '../BuyButton.vue'
import OrderTypeModal from '../OrderTypeModal.vue'
import CarrinhoService from '../../../services/CarrinhoService'
import Loader from '../Loader.vue'
import ProductShippingDetails from '../../ProductShippingDetails'
import ProductInputResume from './ProductInputResume'
import ProposalGenerate from './ProposalGenerate'

export default {
    name: 'Resume',
    props: {
        products: { type: Array, default: [] },
        project: { type: String, default: null },
        codigoProduto: { type: String, default: null },
    },
    components: {
        Loader,
        ProductShippingDetails,
        OrderTypeModal,
        ProductInputResume,
        ProposalGenerate,
    },

    data() {
        return {
            buyCustomProduct: false,
            terms: false,
            carregando: false,
            dialogProposal: false,
            productProposal: null,
            loading: false,
            frete: {
                cep: '',
                totalProduto: 0,
                codigoProduto: '0',
                Peso: 0,
                qtdeProduto: 0,
                codigoCliente: 0,
            },
            transportadora: null,
        }
    },

    methods: {
        addQtde(id) {
            this.$emit('addQtde', id)
            this.openCotacaoFrete()
        },
        subtractQtde(id) {
            this.$emit('subtractQtde', id)
            this.openCotacaoFrete()
        },
        updateProduct(id) {
            this.$emit('updateProduct', id)
        },
        removeProduct(id) {
            this.$emit('removeProduct', { id })
        },
        clear() {
            while (this.products.length > 0) {
                this.removeProduct(this.products[0].id)
            }
            this.carregando = false
        },
        formatoCurrency(valor) {
            const formato = {
                minimumFractionDigits: 2,
                style: 'currency',
                currency: 'BRL',
            }

            return parseFloat(valor).toLocaleString('pt-BR', formato)
        },
        validarQtde(produto) {
            if (produto.qtde < 1) produto.qtde = 1
        },
        updateCount() {
            this.$parent.$parent.getList()
        },
        openCotacaoFrete: function () {
            if (this.frete.cep.length !== 9) return

            const soma = (acc, valor) => acc + valor
            this.frete.totalProduto = this.total
            this.frete.codigoProduto = this.codigoProduto

            const peso = this.products
                .map(
                    (x) =>
                        (x.Insumos.map((y) => y.Peso * y.Quantidade).reduce(soma, 0) +
                            x.Insumos.filter((x) => x.Associados.length > 0)
                                .map((x) => x.Associados.map((x) => x.Peso * x.Quantidade).reduce(soma, 0))
                                .reduce(soma, 0)) *
                        x.qtde
                )
                .reduce(soma, 0)

            const qtde = this.products
                .map((x) => x.qtde)
                .reduce(soma, 0)

            this.frete.Peso = peso
            this.frete.qtdeProduto = qtde
            let session = JSON.parse(localStorage.getItem('usuarioLogado'))
            if (session && session.DadosCliente != null) {
                this.frete.codigoCliente = session.DadosCliente.CliCodigo
            }
            $('#product-shipping-details-modal').modal('show')
            var codigo_painel = 0;
            this.products.forEach((element, index) => {
                var j = element;
                codigo_painel = j.Insumos.filter(a => a.Tipo == "PAINEL")[0].Codigo;
            })

            setTimeout(() => this.$refs.modalFrete.calculaFrete(codigo_painel, true), 300)
        },
        async gerarProposta() {
            let continuar = true

            if (!this.transportadora) {
                continuar = false

                await swal({
                    title: 'Continuar sem selecionar o frete?',
                    icon: 'warning',
                    buttons: ['Não', 'Sim'],
                    dangerMode: true,
                }).then((res) => {
                    if (res) {
                        continuar = true
                    }
                })
            }

            if (!continuar) return

            this.loading = true
            const products = this.products.map((f) => ({
                Codigo: f.Codigo,
                Descricao: f.Descricao,
                Insumos: CarrinhoService.NormalizarInsumos(f.Insumos),
                Quantidade: f.qtde,
            }))

            const data = {
                produtos: products,
            }

            const result = await CarrinhoService.DuplicarProdutos(this.$apiUrl, data)

            const produtosNovos = result.Item1
            const insumosInvalidos = result.Item2

            if (insumosInvalidos) {
                let div = document.createElement('div')

                if (insumosInvalidos.filter((f) => f.includes('Os seguintes componentes tem quantidades incorretas:')).length > 0)
                    div.style.textAlign = 'left'

                let index = 0
                const html = insumosInvalidos.map((f) => {
                    if (index === 0) {
                        index++
                        return `<span>${f}</span><br />`
                    }
                    return `<span>- ${f}</span><br />`
                })

                div.innerHTML = html.join('')

                swal({
                    content: div,
                    icon: 'warning',
                })

                this.loading = false
                return
            }

            this.products.forEach((x, i) => {
                x.Codigo = produtosNovos[i].Codigo
            })

            this.productProposal = this.products[0]
            this.dialogProposal = true
            this.loading = false
        },
        async alterarProposta() {
            let continuar = true

            if (!this.transportadora) {
                continuar = false

                await swal({
                    title: 'Continuar sem selecionar o frete?',
                    icon: 'warning',
                    buttons: ['Não', 'Sim'],
                    dangerMode: true,
                }).then((res) => {
                    if (res) {
                        continuar = true
                    }
                })
            }

            if (!continuar) return

            this.loading = true
            const products = this.products.map((f) => ({
                Codigo: f.Codigo,
                Descricao: f.Descricao,
                Insumos: CarrinhoService.NormalizarInsumos(f.Insumos),
                Quantidade: f.qtde,
            }))

            const data = {
                produtos: products,
            }

            const produtoNovo = await CarrinhoService.DuplicarProdutos(this.$apiUrl, data)

            const prdCodigo = produtoNovo[0].Codigo.split('-')[0]
            const valor = produtoNovo[0].Preco
            const gravou = await CarrinhoService.AlterarProposta(this.$apiUrl, this.project, { prdCodigo, valor })

            if (!gravou) {
                this.loading = false
                return
            }

            localStorage.removeItem('geradoresPeronalizados')
            location.href = `/calculadora-aldo-solar/editar/${this.project}`
        },
        comprar() {
            this.getSession()
                .success(async (session) => {
                    this.carregando = true

                    // Caso exista uma sessão
                    let codigoParametro = -1

                    const mesmosGeradores = CarrinhoService.VerificarGeradoresPersonalizadosDuplicados(this.products)

                    if (mesmosGeradores.length > 0) {
                        this.carregando = false

                        let div = document.createElement('div')

                        const html = mesmosGeradores.map((f) => {
                            return `<span>- ${f}</span><br />`
                        })

                        div.innerHTML = `${'<strong>Os seguintes geradores são exatamente iguais:</strong><br /><br />'}${html.join('')}`

                        swal({
                            content: div,
                            icon: 'warning',
                        })

                        return
                    }

                    if (session.CodigoPedido === -1 && session.CodigoOrcamento === -1) {
                        // Caso não exista nenhum pedido
                        $('#order-type-modal').modal('show')
                    } else {
                        if (session.CodigoPedido != -1) {
                            codigoParametro = session.CodigoPedido
                        } else if (session.CodigoOrcamento != -1) {
                            codigoParametro = session.CodigoOrcamento
                        }

                        // ao ajustar aqui, não esquecer de modificar tbm no arquivo de OrderTypeModal.vue
                        const products = this.products.map((f) => {
                            const insumos = CarrinhoService.NormalizarInsumos(f.Insumos)
                            return {
                                Codigo: f.Codigo,
                                Descricao: f.Descricao,
                                Insumos: insumos,
                                Quantidade: f.qtde,
                                Preco: f.valor,
                            }
                        })

                        try {
                            const data = {
                                codigoPedido: codigoParametro,
                                produtos: products,
                            }

                            console.log('DATA', data)

                            const response = await CarrinhoService.AddCustomProduct(this.$apiUrl, data)

                            if (response.filter((f) => f !== 'sucesso').length > 0) {
                                let div = document.createElement('div')

                                if (response.filter((f) => f.includes('Os seguintes componentes tem quantidades incorretas:')).length > 0)
                                    div.style.textAlign = 'left'

                                let index = 0
                                let html = response.map((f) => {
                                    if (index === 0) {
                                        index++
                                        return `<span>${f}</span><br />`
                                    }
                                    return `<span>- ${f}</span><br />`
                                })

                                div.innerHTML = html.join('')

                                swal({
                                    content: div,
                                    icon: 'warning',
                                })
                            } else {
                                this.updateCount()
                                swal({
                                title: 'Produto adicionado com sucesso!',
                                buttons: ['Continuar a compra', 'Ir para o carrinho'],
                                }).then((goCar) => {
                                if (goCar) {
                                    this.openCart();
                                }
                                });
                                this.carregaDataLayer(products);
                                this.clear();
                            }

                            this.carregando = false
                        } catch (error) {
                            swal({
                                title: 'Ocorreu um erro desconhecido!',
                                icon: 'error',
                            })
                            this.carregando = false
                        }
                    }
                })
                .error((error) => {
                    // Caso não esteja logado, joga para tela de login
                    this.carregando = false
                    if (error.status === 401) this.$router.push('/login?redirectTo=' + window.location.href)
                })
        },
        getSession() {
            return $.ajax({
                url: this.$apiUrl + 'Session.svc/getsessions',
                dataType: 'json',
                type: 'GET',
                xhrFields: { withCredentials: true },
            })
        },
        setTranportadora(transportadora) {
            this.transportadora = transportadora
        },
        carregaDataLayer(value) {
            if (dataLayer) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: [{
                            item_name: value.Descricao,
                            item_id: value.Codigo,
                            price: value.Preco,
                            item_brand: value.Descricao,
                            item_qtd: value.Quantidade
                        }]
                    }
                });
            }
        },
        openCart: function(){
          const self = this
          var isVendaDireta = localStorage.getItem('GetTipoPedido').includes('DIRETA')

          if (isVendaDireta) {
                location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/carrinho`;
          }
          else {location.href = `${self.$SiteUrl}/loja/meu-carrinho/carrinho`;
        }
      },
    },

    computed: {
        isDisabled: function () {
            return !this.terms
        },
        total() {
            const valor = this.products.reduce((acc, product) => acc + product.valor * product.qtde, 0)



            return parseFloat(valor)
        },

        totalFormatado() {
            const formato = {
                minimumFractionDigits: 2,
                style: 'currency',
                currency: 'BRL',
            }

            return parseFloat(this.total).toLocaleString('pt-BR', formato)
        },

        habilitaBuscaFrete() {
            return this.frete.cep.length == 9
        },
    },
}
</script>
